// src/sizing/runUnifiedSizing.ts
import type { NewSizingRequest, NewSizingSnapshot } from './newSizingEngine';
import { runNewSizingEngine } from './newSizingEngine';
import { USE_NEW_PIPELINE } from './pipelineFlags';

export function runUnifiedSizing(req: NewSizingRequest): NewSizingSnapshot {
  if (!USE_NEW_PIPELINE) {
    console.warn('[UnifiedSizing] USE_NEW_PIPELINE disabled; runUnifiedSizing using new engine anyway.');
  }

  try {
    const snapshot = runNewSizingEngine(req);
    console.log('[UnifiedSizing] Snapshot', {
      finalGpuCount: snapshot.finalGpuCount,
      bottleneck: snapshot.finalBottleneck,
      p95Active: snapshot.p95Active,
      kvSessionsP95: snapshot.kvSessionsP95,
      kvGpusP95: snapshot.kvGpusP95,
      requiredPromptTps: snapshot.requiredPromptTps,
      requiredDecodeTps: snapshot.requiredDecodeTps,
    });
    return snapshot;
  } catch (err) {
    console.error('[UnifiedSizing] New engine failed', err);
    throw err;
  }
}
